import React from 'react';
import { Box, Heading } from '@chakra-ui/react';
import FormattedText from './FormattedText';
import LazyRichTextEditor from './LazyRichTextEditor';

const ExperienceSection = ({ isEditing, value, displayValue, onChange }) => (
  <Box bg="white" boxShadow="md" borderRadius="md" p={6}>
    <Heading as="h2" size="md" mb={2}>
      Experience
    </Heading>
    {isEditing ? (
      <LazyRichTextEditor value={value} onChange={onChange} minH="200px" ariaLabel="Experience" />
    ) : (
      <FormattedText text={displayValue} />
    )}
  </Box>
);

export default ExperienceSection;
